import React from 'react';

const WorldMap = ({ className = '' }) => {
  const svgPath = `${process.env.PUBLIC_URL}/images/world.svg`;

  return (
    <img 
        src={svgPath} 
        alt="World map" 
        className={`map-silhouette-icon ${className}`}
        onError={(e) => { e.target.style.display = 'none'; }} 
    />
  );
};

export default WorldMap;
